import { render, staticRenderFns } from "./TPADashboard.vue?vue&type=template&id=7ff91ffa&scoped=true&"
import script from "./TPADashboard.vue?vue&type=script&lang=js&"
export * from "./TPADashboard.vue?vue&type=script&lang=js&"
import style0 from "./TPADashboard.vue?vue&type=style&index=0&id=7ff91ffa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff91ffa",
  null
  
)

export default component.exports